import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
} from "@angular/core";
import * as CustomEditor from "../../../../../assets/ckeditor5-build-encloud/ckeditor";
import DOMPurify from "dompurify";
import { environment } from "src/environments/environment";

@Component({
    selector: "html-editor",
    templateUrl: "./html-editor.component.html",
    styleUrls: ["./html-editor.component.scss"],
})
export class HtmlEditorComponent implements OnChanges {
    private baseUrl = environment.apiUrl;

    @Input() content: string = "";
    @Input() cssClass: string = "editor-300";
    @Input() language: string = "es";

    @Input() items: string[] = [];
    @Input() reset: boolean = false;
    @Input() menuBarVisible: boolean = false;
    @Input() shouldNotGroupWhenFull: boolean = false;

    @Output() ContentSanitized = new EventEmitter<string>();

    public Editor = CustomEditor.Editor;
    public editorInstance: any = null;

    public editor_count: string = "";
    public editorConfig = {};
    private isExternalUpdate = false;

    constructor() {}

    updateEditorConfig() {
        this.editorConfig = {
            simpleUpload: {
                uploadUrl: `${this.baseUrl}/api/HtmlImage/uploadImageClients`,
            },
            language: this.language,
            licenseKey: "GPL",
            wordCount: {
                onUpdate: (stats: any) => {
                    this.editor_count = `Palabras: ${stats.words}, Caracteres: ${stats.characters}`;
                    this.onContentChange();
                },
            },
            toolbar: {
                items: this.items,
                shouldNotGroupWhenFull: this.shouldNotGroupWhenFull,
            },
            menuBar: { isVisible: this.menuBarVisible },
        };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes["items"] ||
            changes["shouldNotGroupWhenFull"] ||
            changes["menuBarVisible"] ||
            changes["language"]
        ) {
            this.updateEditorConfig();
        }

        // Solo actualizar el editor si cambia "content" desde afuera y no es un cambio interno
        if (changes["content"] && this.editorInstance) {
            if (
                !this.isExternalUpdate &&
                this.content !== this.editorInstance.getData()
            ) {
                this.isExternalUpdate = true;
                this.editorInstance.setData(this.content || "");
                this.isExternalUpdate = false;
            }
        }

        if (changes["reset"] && this.reset && this.editorInstance) {
            this.isExternalUpdate = true;
            this.editorInstance.setData("");
            this.ContentSanitized.emit("");
            this.isExternalUpdate = false;
        }
    }

    onReady(editor: any) {
        this.editorInstance = editor;
    }

    updateEditorContent(newContent: string) {
        if (this.editorInstance) {
            this.isExternalUpdate = true;
            this.editorInstance.setData(newContent || "");
            this.isExternalUpdate = false;
        }
    }
    onContentChange() {
        if (!this.isExternalUpdate && this.editorInstance) {
            const rawData = this.editorInstance.getData();

            const sanitizedData = DOMPurify.sanitize(rawData, {
                USE_PROFILES: { html: true },
                FORBID_TAGS: [
                    "script",
                    "iframe",
                    "object",
                    "embed",
                    "style",
                    "svg",
                    "math",
                    "foreignObject",
                ],
                FORBID_ATTR: [
                    "style",
                    "onerror",
                    "onload",
                    "onclick",
                    "onmouseover",
                    "onfocus",
                    "onmouseenter",
                    "onmouseleave",
                ],
                ALLOWED_URI_REGEXP: /^(?!\s*(javascript|data):)/i,
                RETURN_DOM: false,
                RETURN_TRUSTED_TYPE: false,
            });

            this.ContentSanitized.emit(sanitizedData || "");
        }
    }
}
